import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import PageTitlesSM from "./PageTitlesSM";


const EmergenciasSites = () => {
    const navigate = useNavigate();
    return (
        <>
       <div class="container text-center mainContent" >
       <PageTitlesSM texto="Botón de emergencia" icono="./icon_header_emergencia.svg" retorno="/"/>
        <div class="row">
            <div class="col">
                <button class="buttonMainEmergency" onClick={()=>navigate("/emergenciasbotones")}>
Report&aacute; una Emergencia
                </button>
            </div>
        </div>
        
        </div>
        
        </>

    );
    }
export default EmergenciasSites;